import { render, staticRenderFns } from "./SharePosture.vue?vue&type=template&id=0eeda0af&scoped=true&"
import script from "./SharePosture.vue?vue&type=script&lang=js&"
export * from "./SharePosture.vue?vue&type=script&lang=js&"
import style0 from "./SharePosture.vue?vue&type=style&index=0&id=0eeda0af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeda0af",
  null
  
)

export default component.exports